module.exports = __webpack_public_path__ + "media/images/icons/icn_004-bc67483a097a6df4747d81211d3946db.svg";